<template>
  <slot v-if="productResponse" :breadcrumbResponse :productResponse>
    <Breadcrumb
      v-if="breadcrumbResponse"
      :breads="[
        ...breadcrumbResponse.breadcrumb,
        { label: productResponse?.titles?.raw, url: route.path },
      ]"
      class="bg-surface-default-low hidden md:block"
      trackingZone="product"
    />
    <div
      class="flex flex-wrap justify-between gap-x-8 pb-8 ps-24 md:hidden md:p-0 md:ps-0"
    >
      <BreadcrumbProductPage
        v-if="breadcrumbResponse"
        :breads="breadcrumbResponse.breadcrumb"
        class="bg-surface-default-low"
        trackingZone="product"
      />
    </div>
  </slot>
</template>

<script lang="ts" setup>
import { useRoute } from '#imports'

import Breadcrumb from '~/scopes/navigation/components/Breadcrumb/Breadcrumb.vue'
import BreadcrumbProductPage from '~/scopes/product-core/components/presentationals/Breadcrumb/Breadcrumb.vue'
import { useFetchBreadcrumb } from '~/scopes/product-core/composables/useFetch/useFetchBreadcrumb/useFetchBreadcrumb'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'

const { data: breadcrumbResponse } = useFetchBreadcrumb()
const { data: productResponse } = useFetchProduct()

const route = useRoute()
</script>
